import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1581.21035,0 L1581.21035,1468.23529 L1355.328,1468.23529 L1355.328,1807.05882 L1524.73976,1807.05882 L1524.73976,1920 L282.386824,1920 C199.939765,1920 120.880941,1883.85882 67.6856471,1820.61176 C23.7515294,1768.65882 0.0338823529,1704.28235 0.0338823529,1637.64706 L0.0338823529,282.352941 C0.0338823529,126.494118 126.528,0 282.386824,0 L1581.21035,0 Z M1242.38682,1468.23529 L294.810353,1468.23529 C205.586824,1468.23529 128.673882,1528.09412 115.233882,1608.28235 C113.991529,1617.31765 112.975059,1626.35294 112.975059,1635.38824 L112.975059,1637.64706 C112.975059,1678.30588 126.528,1715.57647 153.633882,1747.2 C186.386824,1785.6 232.692706,1807.05882 282.386824,1807.05882 L1242.38682,1807.05882 L1242.38682,1694.11765 L240.598588,1694.11765 L240.598588,1581.17647 L1242.38682,1581.17647 L1242.38682,1468.23529 Z M1468.26918,112.941176 L282.386824,112.941176 C189.662118,112.941176 112.975059,188.611765 112.975059,282.352941 L112.975059,1415.15294 C163.798588,1377.88235 226.932706,1355.29412 294.810353,1355.29412 L1468.26918,1355.29412 L1468.26918,112.941176 Z M1185.88235,903.529412 L1185.88235,1016.47059 L395.294118,1016.47059 L395.294118,903.529412 L1185.88235,903.529412 Z M1242.35294,338.823529 L1242.35294,790.588235 L338.823529,790.588235 L338.823529,338.823529 L1242.35294,338.823529 Z M1129.41176,451.764706 L451.764706,451.764706 L451.764706,677.647059 L1129.41176,677.647059 L1129.41176,451.764706 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1",
  transform: "translate(169)"
});

var IconCoursesLine = /*#__PURE__*/function (_Component) {
  _inherits(IconCoursesLine, _Component);

  var _super = _createSuper(IconCoursesLine);

  function IconCoursesLine() {
    _classCallCheck(this, IconCoursesLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconCoursesLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconCourses",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);

  IconCoursesLine.displayName = "IconCoursesLine";
  return IconCoursesLine;
}(Component);

IconCoursesLine.glyphName = 'courses';
IconCoursesLine.variant = 'Line';
IconCoursesLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconCoursesLine;
export { IconCoursesLine };